"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var CommentsTransformer_1, _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../container/ServiceIdentifiers");
const estraverse = __importStar(require("estraverse"));
const IOptions_1 = require("../../interfaces/options/IOptions");
const IRandomGenerator_1 = require("../../interfaces/utils/IRandomGenerator");
const TransformationStage_1 = require("../../enums/node-transformers/TransformationStage");
const AbstractNodeTransformer_1 = require("../AbstractNodeTransformer");
const NodeGuards_1 = require("../../node/NodeGuards");
const ConditionalCommentObfuscatingGuard_1 = require("./obfuscating-guards/ConditionalCommentObfuscatingGuard");
let CommentsTransformer = CommentsTransformer_1 = class CommentsTransformer extends AbstractNodeTransformer_1.AbstractNodeTransformer {
    constructor(randomGenerator, options) {
        super(randomGenerator, options);
    }
    getVisitor(transformationStage) {
        switch (transformationStage) {
            case TransformationStage_1.TransformationStage.Initializing:
                return {
                    leave: (node) => {
                        if (NodeGuards_1.NodeGuards.isProgramNode(node)) {
                            return this.transformNode(node);
                        }
                    }
                };
            default:
                return null;
        }
    }
    transformNode(rootNode) {
        if (!rootNode.comments || !rootNode.comments.length) {
            return rootNode;
        }
        const comments = this.transformComments(rootNode.comments);
        if (comments.length === 0) {
            return rootNode;
        }
        if (!rootNode.body.length) {
            rootNode.leadingComments = comments;
            return rootNode;
        }
        estraverse.traverse(rootNode, {
            enter: (node) => {
                if (node === rootNode) {
                    return;
                }
                const commentIdx = comments.findIndex((comment) => comment.range && node.range && comment.range[0] < node.range[0]);
                if (commentIdx === -1) {
                    return;
                }
                node.leadingComments = comments.splice(commentIdx, comments.length - commentIdx).reverse();
            }
        });
        if (comments.length > 0) {
            rootNode.trailingComments = comments.reverse();
        }
        return rootNode;
    }
    transformComments(comments) {
        return comments.filter((comment) => CommentsTransformer_1.preservedWords
            .some((preservedWord) => comment.value.includes(preservedWord)) ||
            ConditionalCommentObfuscatingGuard_1.ConditionalCommentObfuscatingGuard.isConditionalComment(comment)).reverse();
    }
};
CommentsTransformer.preservedWords = [
    '@license',
    '@preserve'
];
CommentsTransformer = CommentsTransformer_1 = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(1, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [typeof (_a = typeof IRandomGenerator_1.IRandomGenerator !== "undefined" && IRandomGenerator_1.IRandomGenerator) === "function" ? _a : Object, typeof (_b = typeof IOptions_1.IOptions !== "undefined" && IOptions_1.IOptions) === "function" ? _b : Object])
], CommentsTransformer);
exports.CommentsTransformer = CommentsTransformer;
